<ng-scrollbar visibility="hover" [style.width]="'100%'">
  <div class="page-limit wide">
    <div class="assistants-empty-state-header empty-state">
      <span class="description sub-title">{{ assistantsEmptyStateContent.description }}</span>
    </div>

    <u-button
      *ngIf="isLauncher"
      elementSize="small"
      label="Add Assistant"
      type="primary"
      fontIcon="plus"
      [styles]="{ fontSize: '14px', width: '146px' }"
      (onClick)="openStandard()"
    ></u-button>

    <ng-container *ngIf="initData() && !isLauncher">
      <div
        class="assistants-empty-state-apps"
        data-cy="assistants-empty-state-apps"
        *ngFor="let app of assistantsEmptyStateContent.assistantsApps"
        [ngClass]="{ disabled: app.disabled }"
      >
        <u-icon class="app-icon" [model]="app.icon"></u-icon>
        <div class="app-info">
          <div class="app-text">
            <span class="app-name">{{ app.name }}</span>
            <span class="app-description">{{ app.text }}</span>
          </div>
          <span class="coming-soon" *ngIf="app.disabled">Coming soon</span>
          <u-button
            *ngIf="!app.disabled"
            [label]="app.buttonText"
            [styles]="{ width: '142px', height: '32px' }"
            (onClick)="onClickApp(app.value)"
            [disabled]="disableAddSlackButton && app.name === 'Slack Channels'"
            [escape]="false"
            [pTooltip]="disableAddSlackButton && app.name === 'Slack Channels' ? buttonTooltip : ''"
            tooltipPosition="top"
            tooltipStyleClass="u-tooltip"
          >
          </u-button>
        </div>
      </div>
    </ng-container>
  </div>
</ng-scrollbar>
